<template>
  <report-section title="用户信息" style="position: relative">
    <template v-slot:title-right>
      <edit-button style="position: absolute; right: 0" :inputIsEditable="isEditable" :disabled="isPreviewMode" @onEdit="onEdit"
        @onSave="onSave"></edit-button>
    </template>
    <template v-slot:content>
      <div class="section-user-info" style="width: 100%; padding-right: 90px;">
        <div v-if="isEditable" class="section-user-info-editable">
          <div class="section-user-info-editable-item">
            <key-unit-input title="姓名" v-model="name"></key-unit-input>
            <key-unit-input title="性别" v-model="gender"></key-unit-input>
            <!-- <key-unit-input title="年龄" v-model="age"></key-unit-input> -->
            <key-unit-date-picker title="生日" v-model="birthday" :picker-options="pickerOptions"/>
          </div>
          <div class="section-user-info-editable-item section-user-info-editable-item-last">
            <key-unit-input title="身高" v-model="height"></key-unit-input>
            <key-unit-input title="体重" v-model="weight"></key-unit-input>
            <key-unit-input  title="病案号" v-model="medicalRecordNumber"></key-unit-input>
          </div>
          <div v-if="isShowUserInfoRow3" class="section-user-info-editable-item section-user-info-editable-item-last">
            <key-unit-input title="床号" v-model="bedNumber"></key-unit-input>
            <key-unit-input title="病例号" v-model="medicalRecordNumber"></key-unit-input>
            <key-unit-input title="主管医生" v-model="doctorName"></key-unit-input>
          </div>
        </div>
        <div v-else class="section-user-info-not-editable">
          <!-- 第一行：基本信息六等分 -->
          <div class="user-info-row">
            <div class="user-info-item">
              <span class="label">姓名：</span>
              <span class="value">{{ reportDetailModel.nameStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">性别：</span>
              <span class="value">{{ reportDetailModel.genderStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">年龄：</span>
              <span class="value">{{ reportDetailModel.ageStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">身高：</span>
              <span class="value">{{ reportDetailModel.heightStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">体重：</span>
              <span class="value">{{ reportDetailModel.weightStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">BMI：</span>
              <span class="value">{{ reportDetailModel.bmiStr }}</span>
            </div>
          </div>
          
          <!-- 第二行：设备信息 -->
          <div class="user-info-row">
            <div class="user-info-item">
              <span class="label">病案号：</span>
              <span class="value">{{ reportDetailModel.medicalRecordNumber }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">监测设备：</span>
              <span class="value">{{ getDeviceInfo() }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">监测部位：</span>
              <span class="value">指腹</span>
            </div>
          </div>
          
          <!-- 第三行：额外信息 -->
          <div class="user-info-row" v-if="isShowUserInfoRow3">
            <div class="user-info-item">
              <span class="label">床号：</span>
              <span class="value">{{ reportDetailModel.bedNumber }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">病例号：</span>
              <span class="value">{{ reportDetailModel.medicalRecordNumber }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">主管医生：</span>
              <span class="value">{{ reportDetailModel.doctorName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-divider-mt0"></div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import EditButton from "@c/report-detail/single-blood-oxygen-report/common/edit-button.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";
import KeyUnitInput from "@c/report-detail/single-blood-oxygen-report/common/new-key-unit/key-unit-input.vue";
import { findKey } from "@js/object-tool.js";
import { computeBMI, computeSex } from "@js/common-tool.js";
import KeyUnitDatePicker from "@c/report-detail/single-blood-oxygen-report/common/new-key-unit/key-unit-date-picker.vue";
import dayjs from "dayjs";
export default {
  components: {
    ReportSection,
    EditButton,
    KeyValueUnit,
    KeyUnitInput,
    KeyUnitDatePicker,
  },

  props: {
    reportDetailModel: Object,
    isPreviewMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isEditable: false,
      name: undefined,
      gender: undefined,
      age: undefined,
      birthday: undefined,
      height: undefined,
      weight: undefined,
      bedNumber: undefined,
      medicalRecordNumber: undefined,
      doctorName: undefined,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  computed: {
    isShowUserInfoRow3() {
      return (
        this.reportDetailModel.xyReportTemplateType ==
        SPO2_REPORT_TEMPLATE.广东医科大学附属第二医院
      );
    },

    isShowCaseNumber() {
      return (
        this.reportDetailModel.xyReportTemplateType ==
        SPO2_REPORT_TEMPLATE.河南省儿童医院耳鼻喉科
      );
    },
  },

  created() {
    this.setupUserInfo();
  },

  watch: {
    reportDetailModel() {
      this.setupUserInfo();
    },
  },

  methods: {
    onEdit() {
      this.isEditable = true;
    },

    async onSave() {
      try {
        //名字input上已做限制
        this.validateGender();
        this.validateBirthday();
        this.validateValue(this.height, "身高");
        this.validateValue(this.weight, "体重");
        this.saveUserInfo();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async saveUserInfo() {
      const bmi = computeBMI(this.height, this.weight, 1);
      const sex = computeSex(this.gender);
      const params = {
        reportId: this.reportDetailModel.reportId,
        name: this.name,
        sex: sex,
        // age: this.age,
        birthday: dayjs(this.birthday).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        weight: this.weight,
        height: this.height,
        bmi: bmi,
        bedNumber: this.bedNumber,
        medicalRecordNumber: this.medicalRecordNumber,
        doctorName: this.doctorName,
      };
      try {
        await this.$api.saveBloodOxygenReportUserInfo(params);
        this.isEditable = false;
        this.$emit("onEditUserInfoSucceed");
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    setupUserInfo() {
      this.name = this.reportDetailModel.reportUser.name;
      this.age = this.reportDetailModel.reportUser.age;
      this.gender =
        findKey(USER_GENDER, this.reportDetailModel.reportUser.sex) ?? "";
      this.height = this.reportDetailModel.reportUser.height;
      this.weight = this.reportDetailModel.reportUser.weight;
      this.bedNumber = this.reportDetailModel.reportUser.bedNumber;
      this.medicalRecordNumber =
        this.reportDetailModel.reportUser.medicalRecordNumber;
      this.doctorName = this.reportDetailModel.reportUser.doctorName;
      this.birthday = this.reportDetailModel.reportUser.birthday;
    },

    validateGender() {
      try {
        //为空不做判断
        if (this.gender == "") {
          return;
        }
        if (this.gender != "男" && this.gender != "女") {
          throw "";
        }
      } catch (error) {
        throw "性别只能填男或女";
      }
    },

    validateBirthday() {
      try {
        //为空不做判断
        if (!this.birthday) {
          throw "生日不能为空";
        }
        //判断日期格式
        if (!dayjs(this.birthday).isValid()) {
          throw "日期格式错误";
        }
      } catch (error) {
        throw error;
      }
    },

    validateAge() {
      try {
        //为空不做判断
        if (this.age == "") {
          return;
        }
        //判断整数
        if (this.age.indexOf(".") != -1) {
          throw "不是整数";
        }
        //判断[0,200]
        const ageNumber = Number(this.age);
        if (isNaN(ageNumber)) {
          throw "不是数字";
        }
        if (0 < ageNumber && ageNumber > 200) {
          throw "不属于0-200";
        }
      } catch (error) {
        throw "患者年龄是0-200的整数";
      }
    },

    validateValue(value, name) {
      try {
        //为空不做判断
        if (value == "") {
          return;
        }
        //判断最多一位小数
        if (value.split(".")[1] && value.split(".")[1].length > 1) {
          throw "最多一位小数";
        }
        //判断[0,300]
        const valueNumber = Number(value);
        if (isNaN(valueNumber) || 0 > valueNumber || valueNumber > 300) {
          throw "应为0-300";
        }
      } catch (error) {
        throw `患者${name}${error}`;
      }
    },

    getDeviceInfo() {
     
     const hasValidDeviceNumber = this.reportDetailModel.deviceNumber ? this.reportDetailModel.deviceNumber : '-';
     
     return this.reportDetailModel.sn + ('(' + hasValidDeviceNumber + ')');
   }
  },
};
</script>

<style lang="scss" scoped>
/deep/.section-user-info {
  display: flex;
  width: 100%;

  .key-unit-input {
    width: 140px;
    margin-top: 20px;
  }

  &-not-editable {
    width: 100%;
    display: flex;
    flex-direction: column;

    .user-info-row {
      display: flex;
      align-items: center;
       justify-content: space-between;
      margin-bottom: 12px;
      
      // 第一行六等分
      &:first-child {
        .user-info-item {
          flex: 1;
          margin-right: 15px;
          
          &:last-child {
            margin-right: 0;
            justify-content: flex-end;
          }
        }
      }
      
      // 其他行使用gap布局
      // &:not(:first-child) {
      //   flex-wrap: wrap;
      //   gap: 45px;
        
      //   .user-info-item {
      //     min-width: 200px;
      //     flex-shrink: 0;
      //   }
      //    // 如果是监测部位也右对齐
      //     &:last-child {
      //       margin-left: auto; // 最后一个元素右对齐
      //     }
      // }
       // 第二行：病案号左对齐，监测部位右对齐
       &:nth-child(2) {
        justify-content: space-between;
        
        .user-info-item {
          &:first-child {
            // 病案号左对齐
            flex: 0 0 auto;
          }
          
          &:nth-child(2) {
            // 监测设备居中
            flex: 1;
            justify-content: center;
          }
          
          &:last-child {
            // 监测部位右对齐
            flex: 0 0 auto;
          }
        }
      }
      
      // 第三行正常布局
      &:nth-child(3) {
        flex-wrap: wrap;
        gap: 45px;
        
        .user-info-item {
          min-width: 200px;
          flex-shrink: 0;
        }
      }
    }

    .user-info-item {
      display: flex;
      align-items: center;
      
      .label {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        margin-right: 4px;
        // font-weight: 600;
      }
      
      .value {
        font-size: 16px;
        color: #000;
        font-weight: normal;
      }
    }
  }

  &-editable {
    width: 100%;
    display: flex;
    flex-direction: column;

    &-item {
      display: flex;
      align-items: center;

      &-last {
        margin-top: 20px;
      }
    }

    .key-unit {
      margin-right: 20px;
    }
  }
}
</style>

